module.exports = __webpack_public_path__ + "7f9e5cd8f71ee1948a6e96374ea73fd6.pdf";